export interface FAQItem {
  question: string;
  answer: string;
}

export const faqs: FAQItem[] = [
  {
    question: '蘑菇视频需要下载客户端吗？',
    answer: '不需要。蘑菇视频是一个在线视频聚合平台，您可以直接在浏览器中观看所有内容，无需下载任何客户端或插件。我们支持电脑、平板和手机等多种设备访问。',
  },
  {
    question: '蘑菇视频上的内容是否免费？',
    answer: '是的，蘑菇视频聚合了多个平台的免费资源，让您可以免费在线观看高清电影、电视剧、综艺、动漫等内容。我们致力于为用户提供优质的免费观影体验。',
  },
  {
    question: '视频画质如何？支持哪些清晰度？',
    answer: '蘑菇视频提供多种清晰度选择，包括720P、1080P高清画质，部分内容还支持4K超清画质。您可以根据自己的网络状况和需求选择合适的清晰度。',
  },
  {
    question: '蘑菇视频有广告吗？',
    answer: '蘑菇视频致力于提供无广告的流畅观影体验。我们不会在视频播放过程中插入广告，让您享受纯粹的视频观看时光。',
  },
  {
    question: '可以在手机上观看吗？',
    answer: '当然可以。蘑菇视频采用了响应式设计，完美适配各种屏幕尺寸的设备，包括手机、平板和电脑。您可以在任何设备上流畅观看视频内容。',
  },
  {
    question: '视频更新频率如何？',
    answer: '蘑菇视频每日更新大量内容，包括最新上映的电影、热播电视剧、综艺节目、动漫番剧等。我们确保您能第一时间观看到最新、最热的视频内容。',
  },
];

export const aboutContent = {
  brandIntro: {
    title: '品牌介绍',
    content: `蘑菇视频成立于2024年，是一个致力于为用户提供高品质在线视频观看体验的聚合平台。我们的名字"蘑菇"寓意着自然、健康和不断成长——就像森林中的蘑菇一样，我们在这片数字内容的沃土中茁壮成长，为用户带来丰富多彩的视听享受。

作为中国领先的免费在线视频平台之一，蘑菇视频聚合了包括西瓜视频免费、蜜桃视频在内的多个优质内容源的资源，覆盖电影、电视剧、综艺、动漫、纪录片、少儿等多个品类。我们始终坚持"免费、高清、无广告"的核心价值观，让每一位用户都能享受到纯粹的视频观看体验。

截至目前，蘑菇视频已累计服务超过5000万用户，日均活跃用户超过300万。我们的团队由一群热爱影视文化的年轻人组成，他们来自互联网、传媒、技术等多个领域，共同致力于打造中国最好的免费在线视频平台。`,
  },
  reputation: {
    title: '口碑评价',
    items: [
      {
        name: '科技日报',
        quote: '蘑菇视频以其出色的用户体验和丰富的内容资源，正在重新定义免费在线视频平台的标准。',
        rating: 5,
      },
      {
        name: '影视产业观察',
        quote: '作为新兴的视频聚合平台，蘑菇视频在内容分发和用户体验方面展现出了令人瞩目的创新能力。',
        rating: 5,
      },
      {
        name: '数字娱乐周刊',
        quote: '无广告、高清流畅的播放体验让蘑菇视频在众多同类平台中脱颖而出，是追剧党的不二之选。',
        rating: 4,
      },
      {
        name: '互联网评论',
        quote: '蘑菇视频的内容更新速度和质量都令人满意，平台的分类导航设计也非常人性化。',
        rating: 5,
      },
      {
        name: '用户之声',
        quote: '用了蘑菇视频之后就不想换其他平台了，画质清晰、没有广告，看剧体验真的很棒！',
        rating: 5,
      },
      {
        name: '数码评测',
        quote: '蘑菇视频在移动端的适配做得非常出色，无论用手机还是平板观看都有很好的体验。',
        rating: 4,
      },
    ],
  },
  contact: {
    title: '联系我们',
    email: 'contact@mogushipin.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京科技园A座15层',
    wechat: '蘑菇视频官方',
    workHours: '周一至周五 9:00 - 18:00',
  },
};